"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("chrono-node/dist/locales/el/constants");
const pattern_1 = require("chrono-node/dist/utils/pattern");
const AbstractParserWithWordBoundary_1 = require("chrono-node/dist/common/parsers/AbstractParserWithWordBoundary");
const weeks_1 = require("chrono-node/dist/calculation/weeks");
const PATTERN = new RegExp("(?:(?:\\,|\\(|\\（)\\s*)?" +
    "(?:((?:αυτ[όο]|αυτ[ήη])\\s*τ[οη]|(?:τ[οη]\\s*)?(?:προηγο[ύυ]μεν[οη]|τελευτα[ίι][οα]|περασμ[έε]ν[οη]|επ[όο]μεν[οη]))\\s*)?" +
    `(${pattern_1.matchAnyPattern(constants_1.WEEKDAY_DICTIONARY)})` +
    "(?:\\s*(?:\\,|\\)|\\）))?" +
    "(?:\\s*(αυτ[ήη]ς?\s*τη[νς]|τη[νς]\\s*(?:προηγο[ύυ]μενης?|τελευτα[ίι]ας?|περασμ[έε]νης?|επ[όο]μενης?))\\s*εβδομ[άα]δας?)?" + 
    "(?=\\W|$)", "i");
const PREFIX_GROUP = 1;
const WEEKDAY_GROUP = 2;
const POSTFIX_GROUP = 3;
class ELWeekdayParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return PATTERN;
    }
    innerExtract(context, match) {
        const dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
        const offset = constants_1.WEEKDAY_DICTIONARY[dayOfWeek];
        const prefix = match[PREFIX_GROUP];
        const postfix = match[POSTFIX_GROUP];
        let modifierWord = prefix || postfix;
        modifierWord = modifierWord || "";
        modifierWord = modifierWord.toLowerCase();
        let modifier = null;
        if (modifierWord.match(/προηγο[ύυ]μεν[οη]ς?|τελευτα[ίι][οα]ς?|περασμ[έε]ν[οη]ς?/)) {
            modifier = "last";
        }
        else if (modifierWord.match(/επ[όο]μεν[οη]ς?/)) {
            modifier = "next";
        }
        else if (modifierWord.match(/αυτ[όοήη]ς?/)) {
            modifier = "this";
        }
        const date = weeks_1.toDayJSWeekday(context.refDate, offset, modifier);
        return context
            .createParsingComponents()
            .assign("weekday", offset)
            .imply("day", date.date())
            .imply("month", date.month() + 1)
            .imply("year", date.year());
    }
}
exports.default = ELWeekdayParser;
